import { NavItem, UseNavItemsProps } from 'components/main-nav-bar/types'
import { POST_SCORE_HREF } from 'constants/global'
import React from 'react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useNavItems = ({
  parsedNavItems,
  parsedMobileMenuItems,
  newsDropdownItemsState,
  effectiveIsLoggedIn,
  effectiveCanPostScore,
}: UseNavItemsProps) => {
  const { t } = useTranslation(['strCommonUI'])

  const desktopNavItems = useMemo((): NavItem[] => {
    let baseItems = parsedNavItems

    if (!Array.isArray(baseItems) || baseItems.length === 0) {
      console.warn('[DesktopNavItems] parsedNavItems is empty or invalid.')
      return []
    }

    const newsItemIndex = baseItems.findIndex(item => item.name === t('link.news'))
    if (newsItemIndex >= 0) {
      const updatedItems = [...baseItems]
      updatedItems[newsItemIndex] = {
        ...updatedItems[newsItemIndex],
        dropdownItems: newsDropdownItemsState.length > 0 ? newsDropdownItemsState : [],
      }
      baseItems = updatedItems
    }

    return baseItems
  }, [parsedNavItems, newsDropdownItemsState])

  const dropdownRefs = useMemo(() => {
    const refs = {}
    desktopNavItems.forEach(item => {
      if (item.hasDropdown && item.name) {
        refs[item.name] = React.createRef()
      }
    })
    return refs
  }, [desktopNavItems])

  const mobileNavItems = useMemo((): NavItem[] => {
    let finalMobileItems: NavItem[] = []

    const umbracoMobileItems = parsedMobileMenuItems
    if (!Array.isArray(umbracoMobileItems)) {
      console.warn('[MobileNavItems] parsedMobileMenuItems is not an array.')
      return []
    }

    if (effectiveIsLoggedIn) {
      finalMobileItems.push({
        id: 'nav-m-my-account',
        name: t('link.myAccount', 'My Account'),
        path: '#',
        hasDropdown: true,
        hasArrow: true,
      })

      if (effectiveCanPostScore) {
        finalMobileItems.push({
          id: 'nav-m-post-score',
          name: t('button.postAScore', 'Post a score'),
          path: POST_SCORE_HREF,
          hasDropdown: false,
          hasArrow: false,
          badge: t('badge.new', 'NEW'),
        })
      }
    }

    finalMobileItems = finalMobileItems.concat(
      umbracoMobileItems.map(item => {
        if (item.name === 'News') {
          return {
            ...item,
            dropdownItems: newsDropdownItemsState.length > 0 ? newsDropdownItemsState : [],
            hasArrow: item.hasDropdown,
          }
        }
        return {
          ...item,
          hasArrow: item.hasDropdown,
        }
      })
    )

    return finalMobileItems
  }, [effectiveIsLoggedIn, effectiveCanPostScore, parsedMobileMenuItems, newsDropdownItemsState, t])

  return {
    desktopNavItems,
    mobileNavItems,
    dropdownRefs,
  }
}
